import { create } from 'zustand'

/** A campaign launched in this session: what the home page shows as live. */
export interface ILaunchedCampaign {
   id: string
   name: string
   leads?: number
   areaCodes: string[]
   assistantName: string
   voiceName: string
   launchedAt: number
}

/**
 * In the sandbox there is no backend to list live campaigns from, so the
 * composer records what it launched here and the home page reads it.
 * In the real app the dashboard lists campaigns from the API; this store
 * only carries the "just launched" banner for the first visit back.
 */
export const useLaunchedCampaigns = create<{
   campaigns: ILaunchedCampaign[]
   add: (campaign: ILaunchedCampaign) => void
}>((set) => ({
   campaigns: [],
   add: (campaign) => set((s) => ({ campaigns: [campaign, ...s.campaigns] })),
}))
